import { render, staticRenderFns } from "./NodeDashboard.vue?vue&type=template&id=3fd047f3&scoped=true&"
import script from "./NodeDashboard.vue?vue&type=script&lang=js&"
export * from "./NodeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NodeDashboard.vue?vue&type=style&index=0&id=3fd047f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd047f3",
  null
  
)

export default component.exports